
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"}},[_c('path',{attrs:{"d":"M21.76,9.754v-7.5a1.5,1.5,0,0,0-1.5-1.5h-18a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h6","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M0.76 5.254L21.76 5.254","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.260 17.254 A6.000 6.000 0 1 0 23.260 17.254 A6.000 6.000 0 1 0 11.260 17.254 Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M19.934,15.509l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M10.51 10.504L4.51 10.504 4.51 14.254 8.26 14.254","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    